import glassWallPartTypes from 'components/configurator/types/glassWallPartTypes';
import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IGlassWallGlass from 'components/interfaces/IGlassWallGlass';
import IWall from 'components/interfaces/IWall';
import getRandomId from 'services/objects/getRandomId';

const getPartsCopy = (
  parts: (IGlassWallDoor | IGlassWallGlass)[],
  generateIds: boolean
) =>
  parts.map((part: IGlassWallDoor | IGlassWallGlass) => {
    if (part.type === glassWallPartTypes.door) {
      const door = part as IGlassWallDoor;

      if (door.doorGlassIds == null) {
        return {
          ...door,
          doorID: door.doorID,
        };
      }

      return {
        ...door,
        doorGlassIds: { ...door.doorGlassIds },
        doorGlassNames: { ...door.doorGlassNames },
        doorID: door.doorID,
      };
    }

    const glassArea = part as IGlassWallGlass;

    glassArea.glassIds = glassArea.glassIds == null ? [] : glassArea.glassIds;
    glassArea.glassWidths =
      glassArea.glassWidths == null ? [] : glassArea.glassWidths;

    return {
      ...glassArea,
      glassAreaId: generateIds ? getRandomId() : glassArea.glassAreaId,
      glassIds: [...glassArea.glassIds],
      glassWidths: [...glassArea.glassWidths],
    };
  });

const copyWall = (wall: IWall, generateIds = false): IWall => ({
  ...wall,
  parts: getPartsCopy(wall.parts, generateIds),
  wallID: generateIds ? getRandomId() : wall.wallID,
});

export default copyWall;
